import { render, staticRenderFns } from "./ArbsSettingsCorps.vue?vue&type=template&id=3ba73c1d&"
import script from "./ArbsSettingsCorps.vue?vue&type=script&lang=js&"
export * from "./ArbsSettingsCorps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports